export class RolePopup {
    constructor() {
        let _this = this;
        jQuery(document).ready(function () {
            if ($.fn.fancybox) {
                _this.openPopup();
                jQuery("#role-popup .btn").on('click', function (e) {
                    e.stopImmediatePropagation();
                    _this.submitForm();
                });
            }
        });
    }

    openPopup() {
        jQuery("#role-popup")
            .fancybox({
                buttons: [],
                smallBtn: false,
                clickSlide: false,
                clickOutside: false,
                modal: true,
                touch: {
                    vertical: false,
                    momentum: false
                },
            })
            .trigger('click');
    }

    submitForm() {
        let role = jQuery("#role-in-practice").val();
        let xhr = new XMLHttpRequest();

        xhr.open("POST", '/en/api/role-in-practice/', true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify({
            "role": role
        }));
        $.fancybox.close();
    }
}
